import DayEvent from './DayEvent';

export default DayEvent;
